module.exports = __webpack_public_path__ + "img/turning.ecb9fa32.svg";